import { useTranslation } from "react-i18next";
import { FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { exportReportTab } from "../../api/reportExport";
import { usePrefs } from "../../context/PrefsContext";
import { NeuButton } from "../../components/neu/Neu";

export const ExportButtons = ({ filters, tab = "attendance" }) => {
  const { t } = useTranslation();
  const { lang } = usePrefs();

  const run = async (format) => {
    try {
      await exportReportTab(tab, format, lang, filters);
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  const label = t(`reports.tabs.${tab}`);

  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex gap-2">
        <NeuButton data-testid="export-excel" className="flex items-center gap-2" onClick={() => run("xlsx")}>
          <FileSpreadsheet className="h-4 w-4" /> {t("dashboard.exportExcel")}
        </NeuButton>
        <NeuButton data-testid="export-pdf" className="flex items-center gap-2" onClick={() => run("pdf")}>
          <FileText className="h-4 w-4" /> {t("dashboard.exportPdf")}
        </NeuButton>
      </div>
      <p className="px-1 text-[10px] font-bold text-muted-foreground" data-testid="export-scope">
        {label}
      </p>
    </div>
  );
};
